module.exports = __webpack_public_path__ + "static/media/eventbrite.20f9acec.png";